import { analyticsClient } from "sdks/analytics";
import { EventField } from "sdks/analytics/types";

const sanitizePersonDetails = (personDetails: Record<string, any>): Record<string, any> => {
    const { phone_number, mobile_number, mobileNumber, ...sanitized } = personDetails;
    return sanitized;
};

export const logHomePageImpression = (widgetsDetails?: Record<string, any>) => {
    analyticsClient.logImpression({
        [EventField.ON]: 'Home Page',
        [EventField.OV]: 'widgets',
        [EventField.F1]: widgetsDetails ? JSON.stringify(widgetsDetails) : "",
    });
};

export const logHelpClick = () => {
    analyticsClient.logClick({
        [EventField.ON]: 'Help',
    });
};

export const logYourReferralsClick = () => {
    analyticsClient.logClick({
        [EventField.ON]: 'Your Referrals',
    });
};

export const logProfileClick = () => {
    analyticsClient.logClick({
        [EventField.ON]: 'Profile',
    });
};

export const logEarningsClick = () => {
    analyticsClient.logClick({
        [EventField.ON]: 'Earnings',
    });
};

export const logCityWiseBonusClick = () => {
    analyticsClient.logClick({
        [EventField.ON]: 'City wise Bonus',
    });
};

export const logViewAllReferralsClick = () => {
    analyticsClient.logClick({
        [EventField.ON]: 'View All Referrals',
    });
};

export const logReferNowButtonClick = (referredPersonDetails: Record<string, any>) => {
    const sanitizedDetails = sanitizePersonDetails(referredPersonDetails);
    analyticsClient.logClick({
        [EventField.ON]: 'Refer now',
        [EventField.OV]: 'Button',
        [EventField.F1]: JSON.stringify(sanitizedDetails),
    });
};

export const logBannerWidgetClick = (bannerDetails: Record<string, any>) => {
    analyticsClient.logClick({
        [EventField.ON]: 'banner_widget',
        [EventField.OV]: 'banner_details',
        [EventField.F1]: JSON.stringify(bannerDetails),
    });
};

export const logReferredSuccessfullyCardImpression = (referredPersonDetails: Record<string, any>) => {
    const sanitizedDetails = sanitizePersonDetails(referredPersonDetails);
    analyticsClient.logImpression({
        [EventField.ON]: 'referred_successfully_card',
        [EventField.OV]: 'Referred Successfully!',
        [EventField.F1]: JSON.stringify(sanitizedDetails),
    });
};

export const logReferredSuccessfullyCardReferSomeoneElseClick = () => {
    analyticsClient.logClick({
        [EventField.ON]: 'Referred Successfully Card',
        [EventField.OV]: 'Refer someone else btn',
    });
};

export const logReferredSuccessfullyCardCloseClick = () => {
    analyticsClient.logClick({
        [EventField.ON]: 'Referred Successfully Card',
        [EventField.OV]: 'Close',
    });
};

export const logReferralSuccess = (referredPersonDetails: Record<string, any>, responseData: Record<string, any>) => {
    const sanitizedDetails = sanitizePersonDetails(referredPersonDetails);
    analyticsClient.logImpression({
        [EventField.ON]: 'Refer now',
        [EventField.OV]: 'success',
        [EventField.F1]: JSON.stringify({
            ...sanitizedDetails,
            response: responseData,
        }),
    });
};

export const logReferralError = (errorCode: string, errorResponse: Record<string, any>, requestDetails: Record<string, any>) => {
    const sanitizedRequestDetails = sanitizePersonDetails(requestDetails);
    analyticsClient.logClick({
        [EventField.ON]: 'Refer now',
        [EventField.OV]: 'failure',
        [EventField.F1]: JSON.stringify({
            error_code: errorCode,
            error_response: errorResponse,
            request: sanitizedRequestDetails,
        }),
    });
};

